module.exports = __webpack_public_path__ + "img/mypage.6599ec3a.png";